
import axiosClient from "./axiosClient";

const repairApi = {
  createRepair: (data) => {
    return axiosClient.post("/Repair", data);
  },
  
  getAllRepairs: (status = "", search = "") => {
    return axiosClient.get(`/Repair?status=${status}&search=${search}`);
  },

  getPagedRepairs: (page = 1, pageSize = 20, status = "", search = "") => {
    return axiosClient.get(`/Repair/paged?page=${page}&pageSize=${pageSize}&status=${status}&search=${search}`);
  },

  getRepairDetail: (id) => {
    return axiosClient.get(`/Repair/${id}`);
  },

  updateRepair: (id, data) => axiosClient.put(`/Repair/${id}`, data),
  updateStatus: (id, status) => axiosClient.patch(`/Repair/${id}/status`, { newStatus: status }),
  deleteRepair: (id) => axiosClient.delete(`/Repair/${id}`),
  addPart: (id, data) => axiosClient.post(`/Repair/${id}/parts`, data),
  removePart: (id, partId) => axiosClient.delete(`/Repair/${id}/parts/${partId}`),

  lookupByPhone: (phone) => {
    return axiosClient.get(`/Repair/lookup?phone=${phone}`);
  }
};

export default repairApi;

